import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-04826558"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "header", -1));

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "text-white-50"
}, null, -1));

const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h3 data-v-04826558>main content</h3><h3 data-v-04826558>main content</h3><h3 data-v-04826558>main content</h3><h3 data-v-04826558>main content</h3><h3 data-v-04826558>main content</h3><h3 data-v-04826558>main content</h3><h3 data-v-04826558>main content</h3><h3 data-v-04826558>main content</h3><h3 data-v-04826558>main content</h3><h3 data-v-04826558>main content</h3>", 10);

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "text-white-50"
}, null, -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "footer", -1));

import { onBeforeUnmount, onMounted, ref } from "vue";
export default {
  __name: 'RightAsideNavBar',
  props: {
    mask: {
      default: false,
      type: Boolean
    }
  },
  emits: ['closeNav'],

  setup(__props, {
    emit
  }) {
    const probs = __props;
    const show = ref(true);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass(["right-aside-nav", show.value ? 'start' : 'end']),
        "aria-labelledby": "",
        "aria-modal": "true",
        role: "dialog",
        ref: "nav"
      }, [_createElementVNode("header", null, [_renderSlot(_ctx.$slots, "header", {}, () => [_hoisted_1]), _createElementVNode("button", {
        type: "button",
        class: "btn-close btn-close-white",
        "aria-label": "Close",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('closeNav'))
      })]), _hoisted_2, _createElementVNode("main", null, [_renderSlot(_ctx.$slots, "main", {}, () => [_hoisted_3])]), _hoisted_13, _createElementVNode("footer", null, [_renderSlot(_ctx.$slots, "footer", {}, () => [_hoisted_14])])], 2), __props.mask ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["offcanvas-backdrop", show.value ? 'show' : 'fade']),
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('closeNav'))
      }, null, 2)) : _createCommentVNode("", true)], 64);
    };
  }

};